import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  const location = useLocation();

  return (
    <header className="bg-primary shadow-sm border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://letcheck.b-cdn.net/944/bild-logo-final-dunkel-1726774068395.png" 
              alt="Logo" 
              className="h-10 w-auto"
            />
            <h1 className="text-xl font-semibold text-white">
              Survey Visualizer
            </h1>
          </Link>
          
          {location.pathname !== '/' && (
            <nav className="hidden md:flex items-center space-x-6">
              <Link 
                to="/" 
                className="text-white hover:text-gray-200 transition-colors"
              >
                Startseite
              </Link>
              <Link 
                to="/create" 
                className="text-white hover:text-gray-200 transition-colors"
              >
                Neue Umfrage
              </Link>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;